var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.393 21.154c.345.199.789.248 1.183.248 3.106 0 3.45-3.617 2.909-6.888-.592-3.47-1.874-4.312-2.564-6.988C26.133 3.81 28.942.39 32.69.192a6.274 6.274 0 0 1 5.225 2.33c.395.495.69 1.04.937 1.585 3.944 10.159-4.93 23.143-13.162 23.49a7.299 7.299 0 0 1-2.711-.347c-.346-.1-.74-.248-1.085-.446-.345-.149-.64-.397-.937-.644-.049-.05-.147-.15-.197-.199-.493-.594-.838-1.387-.838-2.23 0-1.883 1.48-3.37 3.352-3.37.838.05 1.529.347 2.12.793z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.999 20.857c.148.1.246.149.394.248.789.595 1.282 1.586 1.282 2.626 0 1.884-1.48 3.37-3.352 3.37-1.923 0-3.303-1.635-3.698-3.42-.887-4.162 3.205-9.514-.591-12.091-.444-.297-1.035-.297-1.528-.297-4.289 0-5.521 7.483-5.226 10.654a17.507 17.507 0 0 0 1.036 4.213c.838 2.13 2.12 4.113 2.12 6.492 0 4.162-3.451 7.532-7.69 7.532A7.762 7.762 0 0 1 .991 36.27c-1.972-3.42-1.282-8.672.74-13.727 2.168-5.5 5.915-10.853 9.464-13.38 2.317-1.685 4.979-2.825 7.838-2.28a8.614 8.614 0 0 1 3.007 1.24c.838.544 1.232.99 1.775 1.833 2.908 4.608-1.824 8.623 1.183 10.902z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.696.787c.05.396.099.842.099 1.239 0 4.162-3.451 7.532-7.69 7.532h-.444a10.343 10.343 0 0 1-.74-1.982C26.133 3.81 28.942.39 32.69.192a6.293 6.293 0 0 1 3.007.595z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.252 36.765a7.743 7.743 0 0 1-6.408 3.37c-.493 0-.937-.05-1.38-.1a4.294 4.294 0 0 1-.69-2.329c0-2.378 1.922-4.311 4.288-4.311 2.021 0 3.747 1.437 4.19 3.37z",
    fill: "#63FFDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.393 21.154c.345.199.789.248 1.183.248 3.106 0 3.45-3.617 2.909-6.888-.592-3.47-1.874-4.311-2.564-6.988-.443-2.081.247-4.014 1.528-5.401.79-.446 1.726-.694 2.712-.744a6.274 6.274 0 0 1 5.225 2.33c.394.495.69 1.04.937 1.585 2.81 7.186-.79 15.71-6.064 20.269-1.774 1.239-3.697 1.982-5.62 2.032a7.3 7.3 0 0 1-2.71-.347c-.296-.1-.641-.198-.937-.347.394.149.838.248 1.281.248 1.874 0 3.352-1.487 3.352-3.37 0-.496-.098-.942-.295-1.338-.395-.942-.937-1.289-.937-1.289zm-4.14 5.253a.596.596 0 0 1-.247-.247l-.197-.199a3.242 3.242 0 0 1-.641-1.14c.05.1.05.15.098.248 0 .05.05.1.05.15.148.296.394.643.64.94.1.1.198.199.296.248z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.513 40.035c-2.366-.396-4.289-1.833-5.423-3.815-1.972-3.42-1.281-8.673.74-13.727 2.169-5.501 5.915-10.853 9.464-13.38 2.17-1.587 4.684-2.677 7.346-2.38l-.05 3.172c-1.084-.396-3.45.347-5.077 1.04-3.944 1.587-5.226 8.178-4.93 11.3a17.503 17.503 0 0 0 1.035 4.212c.838 2.131 2.12 4.113 2.12 6.492 0 3.27-2.169 6.095-5.225 7.087z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.405,
    y1: 11.684,
    x2: 32.066,
    y2: 21.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#6AC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#3AB4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06A1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.047,
    y1: 24.311,
    x2: 7.873,
    y2: 22.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#128DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D4CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.712,
    y1: 7.194,
    x2: 28.531,
    y2: 2.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#CEF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 33.894,
    y1: 24.077,
    x2: 22.992,
    y2: 5.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#CEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#CEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#CEF",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -1.966,
    y1: 30.913,
    x2: 23.959,
    y2: 16.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#FFFFE6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#FFFFE6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFFFE6",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFFFE6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFFFE6",
    stopOpacity: 0.085
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE6",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.5b5b25cff5058e15bc7a55b1195e2683.svg";
export { ForwardRef as ReactComponent };